export default __webpack_public_path__ + "static/media/icons8-map_marker.d8c76f87.svg";